import { z } from 'zod';

/**
 * 이용 통계 이벤트 — PII 없음: 이벤트명 + 날짜별 카운트만 집계 (누가는 모름, 몇 번인지만).
 * 새 이벤트는 여기에만 추가 (doc/analytics.md).
 *  - visit:daily  : 기기당 하루 1회 (localStorage 날짜 가드) → DAU 근사치
 *  - menu:*       : 메뉴 진입 (클라이언트)
 *  - view:*       : 페이지 조회 (클라이언트)
 *  - interpret:*  : 해석 생성 (서버 — 차단 불가, 정확)
 *  - 그 외 서버 액션: room:create, share:publish, login, account:delete, safety:crisis
 */
export const TRACK_EVENTS = [
  'visit:daily',
  'menu:solo',
  'menu:couple',
  'menu:friends',
  'view:history',
  'view:info',
  'view:shared',
  'view:cards',
  'view:card',
  'view:glossary',
  'interpret:solo',
  'interpret:couple',
  'interpret:friends',
  'room:create',
  'room:join',
  'share:publish',
  // 앱인토스 미니앱 리뷰 부탁 — 띄운 횟수와 리뷰 창까지 간 횟수. 별점·후기 내용은 토스에만 남는다
  'review:prompt',
  'review:open',
  'login',
  'account:delete',
  // 위기 발화 감지로 해석 대신 상담 안내를 보여준 횟수 (내용은 남기지 않는다 — 카운트만)
  'safety:crisis',
  // LLM 토큰 사용량 — 카운트가 "횟수"가 아니라 "토큰 수"인 유일한 이벤트.
  // 저장되는 리딩(회원)만이 아니라 모든 생성을 세므로 비용 추정의 근거가 된다 (doc/cost-estimate.md).
  'tokens:in',
  'tokens:out',
] as const;

export type TrackEvent = (typeof TRACK_EVENTS)[number];

export const trackSchema = z.object({ event: z.enum(TRACK_EVENTS) });
